//Scrolls to top of screen
export default function move_to_top() {
    window.scrollTo(0, 0);
}